<template>
    <modal id="district-modal"
           size="default"
           v-model="showModal"
           :title="$t(this.selectedUrl ? 'edit_district' : 'add_district')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader">

        <form :data-url='selectedUrl ? selectedUrl : DISTRICT'
              method="POST"
              ref="form"
              @submit.prevent="submit"
              style="height: 200px"
        >
            <app-form-group
                :label="$t('name')"
                type="text"
                v-model="formData.name"
                :placeholder="$placeholder('name', '')"
                :required="true"
                :error-message="$errorMessage(errors, 'name')"
            />
        </form>
    </modal>
</template>

<script>

import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {DISTRICT} from "../../../../common/Config/apiUrl";

export default {
    name: "BreakTimeCreateEditModal",
    mixins: [FormHelperMixins, ModalMixin],

    data() {
        return {
            DISTRICT
        }
    },
    computed: {},
    methods: {
        submit() {
            let formData = {...this.formData};
            this.loading = true;
            this.message = '';
            this.errors = {};
            this.save(formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#district-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'district-table');
        },
    }
}
</script>